


















































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator';
import { BusyObject } from '@/models/Busy';
import { Brand, BrandsService, PropertyDelta } from '@/api/braendz';

import Popup from '@/components/Popups/Popup.vue'
import BrandDetails from '@/components/Brands/BrandDetails.vue'
import SocialMediaButton from '@/components/Social/SocialMediaButton.vue'
import { DeltaType } from '@/models/Delta';

@Component({
    components: {
        Popup,
        BrandDetails,
        SocialMediaButton
    },
    model: {
        prop: "model",
        event: "visibilityChanged"
    }
})
export default class BrandDetailsPopup extends Vue {
    // Member
    public visibility = false;
    public brand = new BusyObject<Brand>();

    // Properties
    @Prop({ required: false })
    public model?: boolean;

    @Prop({ required: true })
    public id!: string;

    @Prop({ required: false })
    public deltaType?: DeltaType;

    @Prop({ required: false })
    public propertyDeltas?: PropertyDelta[] | null | undefined;

    // Getter & Setter
    public get visible(): boolean {
        return this.model ?? this.visibility;
    }
    public set visible(value: boolean) {
        this.visibility = value;
        this.$emit('visibilityChanged', value);
    }

    public get socialMediaTitle(): string {
        return this.brand.object?.name ? 
            this.$t('brandDetailsPopup.socialMedia.titleBrandName', { name: this.brand.object.name }).toString()
            : this.$t('brandDetailsPopup.socialMedia.title').toString();
    }

    // Watcher
    @Watch('visible')
    public onVisibleChanged(visible: boolean): void {
        if(visible && !this.brand.isBusy && !this.brand.object) {
            this.loadBrand();
        }
    }

    // Methods:
    public async loadBrand() {
        await this.brand.load(async () => {
            return await BrandsService.getBrand(this.id);
        });
    }
}
